<template>
  <section v-if="localContent" ref="advantages">
    <div class="label center">{{ localContent.label }}</div>
    <h2 class="center">{{ localContent.title }}</h2>
    <div class="advantages">
      <div class="advantages__item" v-for="(advantage, index) in localContent.advantages" :key="index">
        <div class="counter" v-if="isVisible">
          <span class="count">{{ advantage.count }}</span>
        </div>
        <div class="advantages__text">{{ advantage.text }}</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CounterSection',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localContent: JSON.parse(JSON.stringify(this.content)),
      isVisible: false
    }
  },
  methods: {
    startCounting() {
      this.localContent.advantages.forEach((advantage, index) => {
        let counter = 0;
        const target = advantage.count;

        setTimeout(() => {
          const interval = setInterval(() => {
            if (counter < target) {
              counter++;
              this.localContent.advantages[index].count = counter;
            } else {
              clearInterval(interval);
            }
          }, 100);
        }, 500);
      });
    },
    checkVisibility() {
      if (!this.$refs.advantages || this.isVisible) return;

      const rect = this.$refs.advantages.getBoundingClientRect();
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        this.isVisible = true;
        this.startCounting();
        window.removeEventListener('scroll', this.checkVisibility);
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.checkVisibility)
    this.checkVisibility();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.checkVisibility);
  },
  watch: {
    content: {
      handler(newContent) {
        this.localContent = JSON.parse(JSON.stringify(newContent));
      },
      deep: true
    }
  }
}
</script>
